import { signOutAction } from "@/app/actions/auth"
import { Button } from "@/components/ui/button"

export function SignOut() {
    return (
        <form action={signOutAction}>
            <Button variant="ghost" type="submit">
                Sign Out
            </Button>
        </form>
    )
}
